import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f1741a2a")

_pushScopeId("data-v-f1741a2a")
const _hoisted_1 = { class: "ca-wrap" }
const _hoisted_2 = { class: "ctr-group" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("分配作业")
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "sep" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "sep" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = { class: "ctr-group" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "sep" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "sep" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("提前结束")
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "sep" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_17 = { style: {"padding-bottom":"14px"} }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", null, "将删除本案例分析全部内容，已进行实验数据不受影响，是否确认删除？", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", null, "将删除该次作业全部数据，是否确认删除？", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", null, "提前结束后学生将无法完成该作业，是否确认提前结束？", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_pagination = _resolveComponent("a-pagination")
  const _component_ManagementFrame = _resolveComponent("ManagementFrame")
  const _component_Modal = _resolveComponent("Modal")
  const _component_DisModal = _resolveComponent("DisModal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ManagementFrame, {
      items: _ctx.eventDispatcher.frames.value,
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.eventDispatcher.handleFrameClick($event))),
      currentIndex: _ctx.eventDispatcher.activeFrame.value
    }, {
      controllers: _withId(() => [
        (_ctx.eventDispatcher.activeFrame.value===0)
          ? (_openBlock(), _createBlock(_component_SvgIcon, {
              key: 0,
              class: "ca-add pointer",
              icon: "add",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.eventDispatcher.handleAddClick()))
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_SvgIcon, {
          class: "ca-back pointer",
          icon: "back",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.backToTeacherHome(_ctx.$router)))
        })
      ]),
      content: _withId(() => [
        (_ctx.eventDispatcher.activeFrame.value===0)
          ? (_openBlock(), _createBlock(_component_a_table, {
              key: 0,
              class: "mb14 teacher-table",
              columns: _ctx.caseAnalysis.columns.value,
              "data-source": _ctx.caseAnalysis.data.list,
              pagination: false,
              loading: _ctx.caseAnalysis.quering.value || _ctx.caseAnalysis.deleting.value,
              "row-key": "id"
            }, {
              operation: _withId(({record}) => [
                _createVNode("div", _hoisted_2, [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.caseAnalysisController.handleDistributeClick(record))
                  }, {
                    default: _withId(() => [
                      _hoisted_3
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _hoisted_4,
                  (_ctx.caseAnalysisController.canEdit(record))
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "link",
                        onClick: ($event: any) => (_ctx.caseAnalysisController.handleEditClick(record))
                      }, {
                        default: _withId(() => [
                          _hoisted_5
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        type: "link",
                        onClick: ($event: any) => (_ctx.caseAnalysisController.handlePreviewClick(record))
                      }, {
                        default: _withId(() => [
                          _hoisted_6
                        ]),
                        _: 2
                      }, 1032, ["onClick"])),
                  _hoisted_7,
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.caseAnalysisController.handleDelClick(record)),
                    disabled: _ctx.caseAnalysisController.disabledDel(record)
                  }, {
                    default: _withId(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"])
                ])
              ]),
              _: 1
            }, 8, ["columns", "data-source", "loading"]))
          : (_openBlock(), _createBlock(_component_a_table, {
              key: 1,
              class: "mb14 teacher-table",
              columns: _ctx.jobView.columns.value,
              "data-source": _ctx.jobView.data.list,
              pagination: false,
              loading: _ctx.jobView.quering.value || _ctx.jobView.loadings.deleting,
              "row-key": "id"
            }, {
              operation: _withId(({record}) => [
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.jobViewController.handleViewClick(record)),
                    disabled: record.assignStatus === 0
                  }, {
                    default: _withId(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"]),
                  (record.jobStatus === "未开始")
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _hoisted_11,
                        _createVNode(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (_ctx.jobViewController.handleDelClick(record))
                        }, {
                          default: _withId(() => [
                            _hoisted_12
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ], 64))
                    : _createCommentVNode("", true),
                  (record.jobStatus === "进行中")
                    ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _hoisted_13,
                        _createVNode(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (_ctx.jobViewController.handleAdvanceClick(record))
                        }, {
                          default: _withId(() => [
                            _hoisted_14
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ], 64))
                    : _createCommentVNode("", true),
                  (record.jobStatus === "已结束")
                    ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                        _hoisted_15,
                        _createVNode(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (_ctx.jobViewController.handleDelClick(record))
                        }, {
                          default: _withId(() => [
                            _hoisted_16
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["columns", "data-source", "loading"])),
        _createVNode("div", _hoisted_17, [
          (_ctx.eventDispatcher.activeFrame.value===0)
            ? (_openBlock(), _createBlock(_component_a_pagination, {
                key: 0,
                class: "ca-page flex justify-end",
                "show-quick-jumper": "",
                total: _ctx.caseAnalysis.data.pagination.totalRecords,
                "page-size": _ctx.caseAnalysis.data.pagination.pageSize,
                current: _ctx.caseAnalysis.data.pagination.pageNo,
                "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => (_ctx.caseAnalysis.data.pagination.pageNo = $event)),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.caseAnalysisController.handlePageChange($event)))
              }, null, 8, ["total", "page-size", "current"]))
            : (_openBlock(), _createBlock(_component_a_pagination, {
                key: 1,
                class: "ca-page flex justify-end",
                "show-quick-jumper": "",
                total: _ctx.jobView.data.pagination.totalRecords,
                "page-size": _ctx.jobView.data.pagination.pageSize,
                current: _ctx.jobView.data.pagination.pageNo,
                "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => (_ctx.jobView.data.pagination.pageNo = $event)),
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.jobViewController.handlePageChange($event)))
              }, null, 8, ["total", "page-size", "current"]))
        ])
      ]),
      _: 1
    }, 8, ["items", "currentIndex"]),
    _createVNode(_component_Modal, {
      visible: _ctx.caseAnalysis.modals.delete,
      okText: "是",
      cancelText: "否",
      onOnOk: _cache[8] || (_cache[8] = ($event: any) => (_ctx.caseAnalysisController.confirmDelCaseAnalysis())),
      onOnCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.caseAnalysisController.cancelDelCaseAnalysis())),
      loading: _ctx.caseAnalysis.deleting.value
    }, {
      content: _withId(() => [
        _hoisted_18
      ]),
      _: 1
    }, 8, ["visible", "loading"]),
    _createVNode(_component_Modal, {
      visible: _ctx.jobView.modals.delete,
      okText: "是",
      cancelText: "否",
      onOnOk: _cache[10] || (_cache[10] = ($event: any) => (_ctx.jobViewController.confirmDelJobView())),
      onOnCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.jobViewController.cancelDelJobView())),
      loading: _ctx.jobView.loadings.deleting
    }, {
      content: _withId(() => [
        _hoisted_19
      ]),
      _: 1
    }, 8, ["visible", "loading"]),
    _createVNode(_component_Modal, {
      visible: _ctx.jobView.modals.advance,
      okText: "是",
      cancelText: "否",
      onOnOk: _cache[12] || (_cache[12] = ($event: any) => (_ctx.jobViewController.confirmAdvanceJobView())),
      onOnCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.jobViewController.cancelAdvanceJobView())),
      loading: _ctx.jobView.loadings.advanceing
    }, {
      content: _withId(() => [
        _hoisted_20
      ]),
      _: 1
    }, 8, ["visible", "loading"]),
    _createVNode(_component_DisModal, {
      visible: _ctx.caseAnalysis.modals.distribution,
      onOnOk: _cache[14] || (_cache[14] = ($event: any) => (_ctx.caseAnalysisController.confirmDistribution($event))),
      onOnCancel: _cache[15] || (_cache[15] = ($event: any) => (_ctx.caseAnalysisController.cancelDistribution())),
      loading: _ctx.caseAnalysis.loadings.distribution,
      currentData: _ctx.caseAnalysis.recordInfo
    }, null, 8, ["visible", "loading", "currentData"])
  ]))
})